import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { PaymentAllocation } from 'src/features/paymentAllocations/utils/types';
import { PaymentAllocationFormSchemaValues } from 'src/features/paymentAllocations/utils/formSchema';

const RESOURCE = '/payments/payment-allocation/';

type MutationFnType = typeof mutationFn;

const mutationFn = ({ ...data }: PaymentAllocationFormSchemaValues): Promise<PaymentAllocation> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreatePaymentAllocation };
